// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-3pryQ";
var _3 = "wrapper_aviasales-1cptU";
var _4 = "holder-37102";
var _5 = "logo-3FXGI";
var _6 = "loader-2m8CK";
var _7 = "aviasalesLoader-1-PTz";
var _8 = "stripesMap-2aY2m";
var _9 = "footer-x3P5h";
var _a = "footer_withErrors-BVUZZ";
var _b = "text-2M1X7";
var _c = "retryButton-1tWG8";
var _d = "showSearchProgressMapMain-ghJYK";
export { _1 as "__esModule", _2 as "wrapper", _3 as "wrapper_aviasales", _4 as "holder", _5 as "logo", _6 as "loader", _7 as "aviasalesLoader", _8 as "stripesMap", _9 as "footer", _a as "footer_withErrors", _b as "text", _c as "retryButton", _d as "showSearchProgressMapMain" }
export default { "__esModule": _1, "wrapper": _2, "wrapper_aviasales": _3, "holder": _4, "logo": _5, "loader": _6, "aviasalesLoader": _7, "stripesMap": _8, "footer": _9, "footer_withErrors": _a, "text": _b, "retryButton": _c, "showSearchProgressMapMain": _d }
